import { parseISO8601Date } from "./dateTimeUtils";

export function dataStorageExceeded(subscription: $TSFixMe) {
  const exceeded =
    subscription?.usage?.data_storage &&
    !!subscription?.data_storage_quota &&
    subscription?.data_storage_quota <= subscription?.usage?.data_storage;
  return exceeded;
}

export function dataStorageAlertExists(subscription: $TSFixMe) {
  const dataStorageAlert =
    dataStorageExceeded(subscription) &&
    subscription?.data_storage_notification_status === "alert_notification" &&
    !!subscription?.data_storage_notification_status_updated_at;
  return dataStorageAlert;
}

export function replaceNewerElementIfDataStorageAlertExist(
  subscription: $TSFixMe,
  timestamp: $TSFixMe,
  currentNode: $TSFixMe,
  hiddenNode: $TSFixMe,
) {
  if (
    dataStorageAlertExists(subscription) &&
    timestamp &&
    new Date(
      parseISO8601Date(
        subscription.data_storage_notification_status_updated_at,
      ),
    ) < timestamp
  ) {
    return hiddenNode;
  }
  return currentNode;
}

export function filterNewerElementsIfDataStorageAlertExist(
  subscription: $TSFixMe,
  values: $TSFixMe,
) {
  if (
    dataStorageAlertExists(subscription) &&
    values &&
    values instanceof Array
  ) {
    const subscriptionUntilDate = new Date(
      parseISO8601Date(
        subscription.data_storage_notification_status_updated_at,
      ),
    );
    return values.filter(
      (value) => !(value.timestamp && subscriptionUntilDate < value.timestamp),
    );
  }
  return values;
}

export const hasAddon = (subscription: $TSFixMe, addon: $TSFixMe) =>
  !!subscription?.addons?.find((a: $TSFixMe) => a.id.indexOf(addon) >= 0);

export const getBaseDataHistoryQuantity = (
  totalAssignedAssets: number,
  baseHistoryLimit: number,
) => totalAssignedAssets * baseHistoryLimit;

export const getTotalDataHistoryQuantity = (
  totalAssignedAssets: number,
  baseHistoryLimit: number,
  dataHistoryTotalAddonQuantity: number,
) =>
  getBaseDataHistoryQuantity(totalAssignedAssets, baseHistoryLimit) +
  dataHistoryTotalAddonQuantity;
